import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  HostListener,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import {ApiService} from '../../shared/services/api.service';
import {InternalService} from '../../shared/services/internal.service';

import {ActivatedRoute, Router} from '@angular/router';


@Component({
  selector: 'app-service-description',
  templateUrl: 'serviceDescription.component.html',
  styleUrls: ['serviceDescription.component.css'],
})
export class ServiceDescriptionComponent implements OnInit, AfterViewInit {
  isLeaf: boolean ;
  category: any = [];
  loader: any = true;
  submitRequestLink: any = '';
  tagRequestLink: any = '';
  isActive: any = false;
  subCategories: any = [];


  constructor(
    public apiService: ApiService,
    public internalService: InternalService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;


  }

  ngAfterViewInit() {
    // const test=  document.getElementById('test1') as HTMLElement;
    // console.log(test)
    // test.className ='red';
    // if(this.apiService.currentDirection ==='ltr'){
    //   const back =document.getElementById('headerBack')as HTMLElement;
    //   back.classList.add('mirrorImage')
    // }

  }

  ngOnInit() {
    // debugger
    this.apiService.getCategory(this.route.snapshot.params.id).subscribe((res: any) => {
      console.log('****',res)
      // this.category = res.res;
      this.subCategories = res.res;
      this.loader = false;
      this.isLeaf = res.res.isleaf;
      this.isActive = res.res.isActive;

      this.submitRequestLink = `https://web.alobodo.com/services?id=` + this.category.id + `&title=` + this.category.title +  `&isLeaf=`+ String(this.isLeaf);
      this.tagRequestLink = `https://web.alobodo.com/services?id=` + this.category.id + `&title=` + this.category.title +  `&isLeaf=true` + '&tagId=' ;


    })
    
    document.querySelector('#nav').scrollIntoView({behavior: 'smooth', block: 'start'});
    this.category = this.route.snapshot.data.Info[0].res;
    // console.log(this.route.snapshot.data.Info[0].res)
    // console.log(this.category);
    if (this.category) {
      // this.router.navigate(['*'])
      this.loader = false;
      // if(localStorage.getItem('isLeaf') === 'true'){
        // this.submitRequestLink = `https://web.alobodo.com/services?id=` + this.category.upCategory.id + `&title=` + this.category.upCategory.title + `&isLeaf=`+  localStorage.getItem('isLeaf');
      // }else{
        // console.log(this.isLeaf)
        // this.submitRequestLink = `https://web.alobodo.com/services?id=` + this.category.id + `&title=` + this.category.title +  `&isLeaf=`+ String(this.isLeaf);
      // }

    }
    // console.log(this.category);
    if (this.category.icon) {
      this.internalService.getMd5(this.category.icon).then(result => {
        this.category.iconImage = result;
      });
    }
    if (this.category.image) {
      this.internalService.getMd5(this.category.image).then(result => {
        this.category.imageBase64 = result;
      });
    }

    if (this.category.subCategoies) {
      for (let item of this.category.subCategoies) {
        if (item.image) {
          this.internalService.getMd5(item.image).then(result => {
            item.base64 = result;
          });
        }
        for (const tag of item.tags) {
          if (tag.image) {
            this.internalService.getMd5(tag.image).then(base64Result => {
              tag.base64 = base64Result;
            });
          }

        }
      }
    }
    if (this.category.skills) {
      for (let item of this.category.skills) {
        if (item.image) {
          this.internalService.getMd5(item.image).then(result => {
            item.base64 = result;
          });
        }
      }
    }

  }


  getData() {
    // [routerLink]="['/service-description/'+category.upCategory.id+'/'+internalService.getRideOfSpace(category.upCategory.title)]"
    // this.internalService.setIsLeaf();
    this.router.navigate(['service-description/' + this.category.upCategory.id]);

  }


}
